import { WorkflowKind, IWorkflow, IDisposable, IWorkflowSite, IWorkflowContext, IWorkflowActions, IWorkflowDefinition } from '@augloop/interfaces';

export type SingleItemWorkflowLambdaFunction<T> = (input: T, context: IWorkflowContext, actions: IWorkflowActions) => void;

export interface SingleItemWorkflowLambda<T> extends IDisposable {
    init: InitLambda;
    execute: SingleItemWorkflowLambdaFunction<T>;
}

interface SingleItemWorkflowConstructor<T> {
    new(): SingleItemWorkflowLambda<T>;
}

export type InitLambda = (site: IWorkflowSite) => Promise<void>;

export class SingleItemWorkflow<T> implements IWorkflow {
    public readonly kind: WorkflowKind = WorkflowKind.SingleItem;
    public readonly id: string;
    public readonly resourceId: string;
    public inputTypes: string[];
    public outputTypes: string[];
    public factory: () => SingleItemWorkflowLambda<T>;

    public constructor(id: string, opts?: IWorkflowDefinition) {
        this.id = id;

        if (opts) {
            this.inputTypes = opts.inputTypes ?? this.inputTypes;
            this.outputTypes = opts.outputTypes ?? this.outputTypes;
        }
    }

    public static create<T>(id: string): SingleItemWorkflow<T> {
        return new SingleItemWorkflow(id);
    }

    public setInputTypes(itemTypes: string[]): SingleItemWorkflow<T> {
        this.inputTypes = itemTypes;
        return this;
    }

    public setOutputTypes(outputTypes: string[]): SingleItemWorkflow<T> {
        this.outputTypes = outputTypes;
        return this;
    }

    public setLambdaType(ctr: SingleItemWorkflowConstructor<T>): SingleItemWorkflow<T> {
        this.factory = () => new ctr();
        return this;
    }

    public setLambda(lambda: SingleItemWorkflowLambdaFunction<T>, initLambda?: InitLambda): SingleItemWorkflow<T> {
        this.factory = () => ({
            init: initLambda ? initLambda : (_) => { return Promise.resolve(); },
            execute: lambda,
            dispose: () => {}
        });

        return this;
    }
}
